import React from 'react'
import dayjs from 'dayjs'

import './index.scss'

const ListMetricVariation = ({ metricVariation, tooltip, tooltiLabel, tooltipVariationMessage }) => {
  if (!metricVariation || metricVariation === 0) {
    return null
  }

  const currentMonth = dayjs().subtract('1', 'month').format('MMM')
  const lastMonth = dayjs().subtract('2', 'month').format('MMM')

  return (
    <div className={`ListMetricVariation ${tooltiLabel && 'tooltiLabel'}`}>
      <div
        className={`variation-centered ${tooltip && 'tooltipped tooltipped-n tooltipped-multiline'} `}
        aria-label={tooltipVariationMessage ? tooltipVariationMessage : `From ${lastMonth} to ${currentMonth}`}
      >
        <span
          className={`metric-variation ${
            metricVariation > 0 ? 'metric-variation-positive' : 'metric-variation-negative'
          }`}
        >
          {metricVariation > 0 && <>+</>}
          {`${metricVariation.toFixed(1)}%`}
        </span>
      </div>
      <div className="ListMetricVariation-date">{tooltiLabel && `${lastMonth}-${currentMonth}`}</div>
    </div>
  )
}

export default ListMetricVariation
